document.querySelector('.searchform').addEventListener('input', function (event) {
    let query = event.target.value;
    fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
            let searchResults = data.resources.results.products;

            // Fetch all SKUs and match manually
            fetch('/products.json')
                .then(response => response.json())
                .then(productData => {
                    let matchingProducts = productData.products.filter(product => {
                        return product.variants.some(variant => 
                            variant.sku.toLowerCase().includes(query.toLowerCase())
                        );
                    });

                    displaySearchResults([...searchResults, ...matchingProducts]);
                });
        });
});

function displaySearchResults(products) {
    let resultsContainer = document.querySelector('#search-results');
    resultsContainer.innerHTML = "";
    products.forEach(product => {
        let item = document.createElement('div');
        item.innerHTML = `<a href="${product.url}">${product.title}</a>`;
        resultsContainer.appendChild(item);
    });
}



// function updateTotalPrice() {

//    // console.log("============== trigger ==============");

//   // Check if quantity break block exists
//   const block =
//     document.getElementById("shopify-block-AVmZNcGJiRkhtNmNhN__product_quantity_breake_product_NDx6UG") ||
//     document.querySelector('[id*="product_quantity_breake_product"]');

//   if (!block) return;

//   // ONLY RUN WHEN BLOCK IS HIDDEN
//   const isHidden = window.getComputedStyle(block).display === "none";
//   if (!isHidden) return; // ignore if visible

//   console.log("============== trigger Display None==============");

//   // Get quantity
//   const qtyInput = document.querySelector('input[name="quantity"]');
//   if (!qtyInput) return;

//   let quantity = parseInt(qtyInput.value) || 0;

//   // Try using global selectedPrice (from your app)
//   let unitPrice = typeof selectedPrice !== "undefined" ? selectedPrice : null;

//   // Fallback to DOM price
//   if (!unitPrice) {
//     const priceEl = document.querySelector("#price .price");
//     if (!priceEl) return;

//     let priceText = priceEl.innerText.replace(/[^0-9.]/g, "");
//     unitPrice = parseFloat(priceText) || 0;
//   }

//   // Calculate total
//   let total = (unitPrice * quantity).toFixed(2);

//   // Update UI
//   const totalEl = document.querySelector("#total strong");
//   if (totalEl) {
//     totalEl.innerText = total;
//   }
// }

// document.addEventListener("click", function (e) {
//   // PLUS button
//   if (e.target.closest(".plus")) {
//     console.log("===========Plus trigger===========");
//     setTimeout(updateTotalPrice, 200);
//   }

//   // MINUS button
//   if (e.target.closest(".minus")) {
//     setTimeout(updateTotalPrice, 200);
//   }
// });



function updateTotalPrice() {
  console.log("==============  new trigger ==============");

  // ==============================
  // ✅ GET INPUTS
  // ==============================
  const qtyInput = document.querySelector('input[name="quantity"]');
  const productQuantityInput = document.querySelector('input[name="product_quantity"]');

  if (!qtyInput) return;

  let quantity = parseInt(qtyInput.value) || 0;
  let maxQty = productQuantityInput ? parseInt(productQuantityInput.value) || 0 : 0;

  // console.log("quantity", quantity);
  // console.log("maxQty", maxQty);

  // =====================================================
  // ✅ ONLY RUN LOGIC WHEN quantity > maxQty
  // =====================================================
  if (maxQty && quantity > maxQty) {
    // console.log("⚠️ Quantity exceeded → applying fallback discount");

    let effectiveQty = maxQty;

    const discountItems = document.querySelectorAll('#discountOptions li');

    let selectedItem = null;
    let closest = 0;

    discountItems.forEach(li => {
      let range = parseInt(li.getAttribute('data-range')) || 0;

      if (range <= effectiveQty && range >= closest) {
        closest = range;
        selectedItem = li;
      }
    });

    if (selectedItem) {
      // console.log("Selecting discount:", closest);

      // 🔥 CLICK li (Shopify safe)
      selectedItem.click();

      // fallback (some themes use label)
      const label = selectedItem.querySelector('label');
      if (label) label.click();
    }
  } else {
    console.log("✅ Within limit → do nothing");
  }

  // =====================================================
  // ✅ PRICE CALCULATION (ALWAYS RUN)
  // =====================================================
  let unitPrice = typeof selectedPrice !== "undefined" ? selectedPrice : null;

  if (!unitPrice) {
    const priceEl = document.querySelector("#price .price");
    if (!priceEl) return;

    let priceText = priceEl.innerText.replace(/[^0-9.]/g, "");
    unitPrice = parseFloat(priceText) || 0;
  }

  let total = (unitPrice * quantity).toFixed(2);

  const totalEl = document.querySelector("#total strong");

  if (totalEl) {
    totalEl.innerText = total;
  }

  // console.log("Total updated:", total);
}
document.addEventListener("click", function (e) {
  // PLUS button
  if (e.target.closest(".plus")) {
    console.log("===========Plus alirazatrigger===========");
    setTimeout(updateTotalPrice, 200);
  }

  // MINUS button
  if (e.target.closest(".minus")) {
    setTimeout(updateTotalPrice, 200);
  }
});
// CLICK (buttons)
document.addEventListener("click", function (e) {
  if (e.target.closest(".plus, .minus, .qty-plus, .qty-minus")) {
    setTimeout(updateTotalPrice, 200);
  }
});

// INPUT (typing)
document.addEventListener("input", function (e) {
  if (e.target.matches('input[name="quantity"]')) {
    updateTotalPrice();
  }
});

// CHANGE (most reliable)
document.addEventListener("change", function (e) {
  if (e.target.matches('input[name="quantity"]')) {
    setTimeout(updateTotalPrice, 200);
  }
});

// Shopify section reload
document.addEventListener("shopify:section:load", function () {
  updateTotalPrice();
});





